import { formatAddress } from "../../services/googleApi"
import { addRecord } from "../../services/api"

const onSubmitFactory = (navigate, setIsSubmitting, setError) => async (data) => {
	try {
		console.log("I am trying to submit")
		setIsSubmitting(true)
		let shipping_address, shipping_city, shipping_postalcode, shipping_additional_address_line
		if (data.shipping_address) {
			// Assuming formatAddress function extracts and formats address, city, and postal code from the Google Places object
			;[shipping_address, shipping_city, shipping_postalcode] = await formatAddress(data.shipping_address)
			shipping_additional_address_line = data.manual_shipping_additional_address_line
		} else {
			// Use the manual address fields directly from the form data
			shipping_address = data.manual_shipping_address
			shipping_city = data.manual_shipping_city
			shipping_postalcode = data.manual_shipping_postal_code
			shipping_additional_address_line = data.manual_shipping_additional_address_line
		}

		// Validate that we have all parts of the address, whether from Google Places or manual entry
		if (!shipping_address || !shipping_city || !shipping_postalcode) {
			throw new Error("Incomplete shipping address")
		}
		let billing_address, billing_city, billing_postalcode, billing_additional_address_line
		if (data.toggle !== "true") {
			// Use shipping address for billing
			billing_address = shipping_address
			billing_city = shipping_city
			billing_postalcode = shipping_postalcode
			billing_additional_address_line = shipping_additional_address_line
		} else if (data.address) {
			;[billing_address, billing_city, billing_postalcode] = await formatAddress(data.address)
			billing_additional_address_line = data.manual_billing_additional_address_line
		} else {
			billing_address = data.manual_billing_address
			billing_city = data.manual_billing_city
			billing_postalcode = data.manual_billing_postal_code
			billing_additional_address_line = data.manual_billing_additional_address_line
		}

		// Validate that we have all parts of the billing address
		if (!billing_address || !billing_city || !billing_postalcode) {
			throw new Error("Incomplete billing address")
		}
		const formData = new FormData()
		formData.append("firstname", data.firstname)
		formData.append("lastname", data.lastname)
		formData.append("birth", data.birth)
		formData.append("email", data.email)
		formData.append("phone", data.phone)
		formData.append("address", billing_address)
		formData.append("additional_address_line", billing_additional_address_line)
		formData.append("city", billing_city)
		formData.append("postalcode", billing_postalcode)
		formData.append("shipping_address", shipping_address)
		formData.append("shipping_additional_address_line", shipping_additional_address_line)
		formData.append("shipping_city", shipping_city)
		formData.append("shipping_postalcode", shipping_postalcode)
		formData.append("social_security", data.social_security)
		data.organism_amc && formData.append("organism_amc", data.organism_amc._id)
		formData.append("accept", data.accept)
		formData.append("no_order", false)
		// formData.append("size", data.size)
		if (data.needMeasurements) {
			data.mesure_ankle && formData.append("mesure_ankle", data.mesure_ankle)
			data.mesure_thigh && formData.append("mesure_thigh", data.mesure_thigh)
			data.mesure_leg && formData.append("mesure_leg", data.mesure_leg)
		}
		if (data.needShoeSize) {
			data.shoe_size && formData.append("shoe_size", data.shoe_size)
		}
		if (data.needWristBrace === "true") {
			data.wrist_side && formData.append("wrist_side", data.wrist_side)
		}
		data.prescriber && formData.append("prescriber", data.prescriber._id)
		data.article && formData.append("article", data.article._id)
		data.prescription[0] && formData.append("prescription", data.prescription[0])
		console.log("a")
		data.prescription_bis && data.prescription_bis[0] && formData.append("prescription_bis", data.prescription_bis[0])
		console.log("b")
		data.prescription_ter && data.prescription_ter[0] && formData.append("prescription_ter", data.prescription_ter[0])
		console.log("c")
		data.mutual_photo && data.mutual_photo[0] && formData.append("mutual_photo", data.mutual_photo[0])
		data.surgery_date && formData.append("surgery_date", data.surgery_date)
		await addRecord(formData)
		navigate("/success")
	} catch (err) {
		console.log(err)
		setIsSubmitting(false)
		if (err.response && err.response.data && err.response.data.cause === "Prescription is missing") {
			setError("prescription", {
				type: "custom",
				message: "Si vous ne parvenez pas à joindre le fichier, basculez sur le navigateur Google Chrome",
			})
		} else if (err.message === "address") {
			setError("address", { type: "custom", message: "On attend une adresse postale" })
		} else if (err.message === "shipping_address") {
			setError("shipping_address", { type: "custom", message: "On attend une adresse postale" })
		} else {
			alert(
				"La commande a échoué pour des raisons inconnues. Veuillez contacter le support MEDICORTHO par mail à commande@medicortho.fr ou par téléphone au 03 21 09 25 96",
			)
		}
	}
}

export default onSubmitFactory
